import React, { FC } from "react";
import { Row, Col, Button, Tag, Grid } from "antd";

const { useBreakpoint } = Grid;

interface LabelValueProps {
  label: string;
  value: any;
  color?: string;
  sm?: number;
  className?: string;
  textAlign?: "center" | "left" | "right";
  textSize?: number;
  bold?: "true" | "false" | "left" | "right";
  mb?: number;
  type?: "text" | "img" | "action" | "link";
  onClick?: () => void;
  underline?: boolean;
  tag?: boolean;
  icon?: React.ElementType;
  labelColor?: string;
  valueColor?: string;
}

const LabelValue: FC<LabelValueProps> = ({
  label,
  value,
  color = "black",
  sm = 8,
  className = "",
  textAlign = "left",
  textSize = 14,
  bold = "true",
  mb = 8,
  type = "text",
  onClick = () => {},
  underline = false,
  tag = false,
  icon,
  labelColor,
  valueColor,
}) => {
  const screens = useBreakpoint();

  const isMobile = !screens.sm;
  const finalTextSize = isMobile ? textSize - 1 : textSize;

  const displayValue =
    value == null || (typeof value === "string" && value.trim() === "")
      ? "Không có dữ liệu"
      : String(value);

  const boldLeft = bold === "true" || bold === "left";
  const boldRight = bold === "true" || bold === "right";

  return (
    <Row style={{ marginBottom: mb }} className={className}>
      <Col
        xs={12}
        sm={sm}
        style={{
          fontSize: finalTextSize,
          color: labelColor ?? color,
          display: "flex",
          alignItems: "center",
        }}
      >
        {boldLeft ? <strong>{label}</strong> : `${label}`}
      </Col>
      <Col
        xs={12}
        sm={24 - sm}
        style={{
          fontWeight: boldRight ? 500 : undefined,
          color: valueColor ?? color,
          textAlign,
          fontSize: finalTextSize,
          display: icon ? "flex" : "block",
          alignItems: icon ? "center" : undefined,
          justifyContent: type === "action" ? "flex-end" : undefined,
        }}
        className={`${underline ? "border-b border-gray-300 pb-1" : ""}`}
      >
        {type === "img" ? (
          <div className="item-row-container">
            <div className="status-text">
              {displayValue !== "Không có dữ liệu" ? "Đã có" : "Chưa có"}
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
              {displayValue !== "Không có dữ liệu" && (
                <div className="fake-btn-link" onClick={onClick}>
                  Xem chi tiết
                </div>
              )}
            </div>
          </div>
        ) : tag ? (
          <Tag color={color}>{displayValue}</Tag>
        ) : type === "action" ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {displayValue}
            {icon && (
              <Button
                type="link"
                size="small"
                onClick={onClick}
                style={{ marginLeft: 4, padding: 0, height: "auto" }}
                icon={React.createElement(icon)}
              />
            )}
          </span>
        ) : type === "link" ? (
          <Button type="link" onClick={onClick} style={{ padding: 0 }}>
            {displayValue}
          </Button>
        ) : (
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
          >
            {displayValue}
            {icon && (
              <span style={{ marginLeft: 4 }}>{React.createElement(icon)}</span>
            )}
          </span>
        )}
      </Col>
    </Row>
  );
};

export default LabelValue;
